import { $freePost } from '@js/request'
import { compress } from '@js/tool'

export async function sendSMS (isEmail: boolean, mobile: string, email: string, captchaAtt: number[]): Promise<void> {
  const data: { [k: string]: any } = {}
  if (isEmail) {
    data.email = email
  } else {
    data.mobile = compress(mobile)
    data.template_code = 'SMS_182920835'
    data.captchaAtt = captchaAtt
  }
  const res = await $freePost(isEmail ? '/api/common/emailCaptcha' : '/api/common/smsCaptcha', data)
  return res.data
}
